const Footer = () => {
  return (
    <footer className="bg-black text-white py-4 px-2 sm:px-6 w-full text-center border-t border-gray-700">
      <p className="text-sm sm:text-base">
        Copyright &copy; {new Date().getFullYear()} |{" "}
        <span className="font-semibold text-amber-400">
          Ortopedia Nuevo Horizonte
        </span>
      </p>
    </footer>
  );
};

export default Footer;
